import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { logout } from 'logout';
import { automaticService } from 'services';

export const getDeviceWorkOrders = createAsyncThunk(
    "getDeviceWorkOrders",
    async ({
        startDate,
        endDate,
        productType,
        skip,
        limit,
        searchExp
    },
        { rejectWithValue }
    ) => {
        try {
            return await automaticService.getDeviceWorkOrders(
                startDate,
                endDate,
                productType,
                skip,
                limit,
                searchExp
            );
        } catch (error) {
            if (error.message) {
                if (error?.response?.status === 401) {
                    logout()
                }
                //No response to request (No service)
                console.log("Internet Disconnected")
            } else {
                console.log(error);
                return (rejectWithValue)
            }
        }
    }
)


const initialState = {
    result: null,
    loading: null,
    error: null
}

const deviceWorkOrdersSlice = createSlice({
    name: "deviceWorkOrders",
    initialState: initialState,
    reducers: {
        clearDeviceWorkOrders: (state, _action) => {
            state.result = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getDeviceWorkOrders.pending, (state, _action) => {
            state.loading = true;
        });
        builder.addCase(getDeviceWorkOrders.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action.payload;
            state.error = null;
        });
        builder.addCase(getDeviceWorkOrders.rejected, (state, action) => {
            state.loading = false;
            state.result = null;
            state.error = action.payload;
        });
    },
})


export const { clearDeviceWorkOrders } = deviceWorkOrdersSlice.actions;

export default deviceWorkOrdersSlice.reducer;